import { AlertTriangle, CalendarClock } from 'lucide-react';
import { RosterPublicationStatus } from '../../services/rosterService';

interface Props {
    status: Exclude<RosterPublicationStatus, 'PUBLISHED'>;
    context?: 'roster' | 'timesheet';
}

const RosterAvailabilityNotice = ({ status, context = 'roster' }: Props) => {
    const unpublished = status === 'UNPUBLISHED';
    const title = context === 'timesheet'
        ? 'Timesheet submission unavailable'
        : unpublished
            ? 'Roster temporarily unavailable'
            : 'Roster not published yet';
    const message = context === 'timesheet' && unpublished
        ? "Timesheet submission is unavailable while today's roster is being amended. Please come back once the roster has been published."
        : unpublished
            ? 'Your roster is temporarily unavailable while amendments are being made. Please check back once it has been published.'
            : 'No published roster is available for this month yet. Please check back later.';
    const Icon = unpublished ? AlertTriangle : CalendarClock;

    return (
        <div className={`rounded-lg border p-4 flex items-start gap-3 ${unpublished ? 'border-amber-200 bg-amber-50 text-amber-900' : 'border-slate-200 bg-white text-slate-700'}`}>
            <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${unpublished ? 'text-amber-600' : 'text-slate-400'}`} />
            <div>
                <p className="font-semibold">{title}</p>
                <p className="mt-1 text-sm">{message}</p>
            </div>
        </div>
    );
};

export default RosterAvailabilityNotice;
